/* eslint-disable */

import React from "react";
import { useState } from "react";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import {
  fetchDeveloperToolsQueryDatabase,
  fetchDeveloperToolsSendEmail,
} from "../../../services/api-raindrop";
import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider.js";

const EmailSelectorContactUs = ({ selectedUrl, setSelectedUrl }) => {
  const urlPrefx = "/email/contact-us";

  const selected = selectedUrl && selectedUrl.startsWith(urlPrefx);

  const onClick = () => {
    setSelectedUrl("/email/contact-us?fullName=Rhaz");
  };

  let colorBorder = "border-color-dark-border-secondary";
  let hover = "hover:scale-95";
  if (selected) {
    colorBorder = "border-color-raindrop-primary";
    hover = "";
  }

  return (
    <div
      className={`flex flex-col w-full p-4 rounded-lg bg-color-dark-background-secondary gap-4 border ${colorBorder} ${hover} transition-all`}
      onClick={onClick}
    >
      <div>
        <div className="font-bold">Contact Us</div>
        <div className="text-xs text-color-dark-text-secondary">{urlPrefx}</div>
      </div>
      <div>
        <RaindropInput
          example={"Hello"}
          label={"Full Name"}
          isShowLabel={true}
          icon={""}
        />
      </div>
    </div>
  );
};

const EmailSelectorInvestor = ({ selectedUrl, setSelectedUrl }) => {
  const urlPrefx = "/email/invitation-organisation";

  const selected = selectedUrl && selectedUrl.startsWith(urlPrefx);

  const onClick = () => {
    setSelectedUrl("/email/invitation-organisation?fullName=Rhaz");
  };

  let colorBorder = "border-color-dark-border-secondary";
  let hover = "hover:scale-95";

  if (selected) {
    colorBorder = "border-color-raindrop-primary";
    hover = "";
  }

  return (
    <div
      onClick={onClick}
      className={`flex flex-col w-full p-4 rounded-lg bg-color-dark-background-secondary gap-4 border transition-all ${hover} ${colorBorder} `}
    >
      <div>
        <div className="font-bold">Investor Invitation</div>
        <div className="text-xs text-color-dark-text-secondary">{urlPrefx}</div>
      </div>

      <div>
        <RaindropInput
          example={"Hello"}
          label={"Full Name"}
          isShowLabel={true}
          icon={""}
        />
      </div>
    </div>
  );
};

const PanelLeft = ({ selectedUrl, setSelectedUrl }) => {
  const [recipient, setRecipient] = useState("rhaz.solomon@gmail.com");
  const [isSending, setIsSending] = useState(false);

  const onSubmit = () => {
    setIsSending(true);

    fetchDeveloperToolsSendEmail({
      recipient: recipient,
      emailURL: selectedUrl,
    })
      .then((response) => {
        console.log("Email sent", response);
      })
      .catch((error) => {
        console.error("Error sending email", error);
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <div className="flex flex-col w-full h-full gap-4">
      <div className="flex flex-col p-4 bg-color-dark-background-secondary rounded-lg border border-color-dark-border-secondary gap-4 items-end">
        <RaindropInput
          value={recipient}
          onChange={(e) => setRecipient(e.target.value)}
          icon="email"
          label={"Recipient"}
          isShowLabel={true}
        />
        <RaindropInput
          value={selectedUrl}
          icon=""
          label={"URL"}
          isShowLabel={true}
          isEditing={false}
        />
        <RaindropDivider />
        <RaindropButton
          onClick={onSubmit}
          style={ButtonStyle.Primary}
          icon="fa-paper-plane"
          isLoading={isSending}
          title="Send Email"
        />
      </div>
      <RaindropDivider />
      <RaindropScrollContainer>
        <EmailSelectorContactUs
          selectedUrl={selectedUrl}
          setSelectedUrl={setSelectedUrl}
        />
        <EmailSelectorInvestor
          selectedUrl={selectedUrl}
          setSelectedUrl={setSelectedUrl}
        />
      </RaindropScrollContainer>
    </div>
  );
};

const PanelRight = ({ url }) => {
  return (
    <div className="flex flex-col w-full h-full  p-4 bg-color-dark-background-tertiary">
      <iframe src={url} className={"w-full h-full"} />
    </div>
  );
};

const NimbusDeveloperToolsEmails = () => {
  const [selectedUrl, setSelectedUrl] = useState("/email/contact-us");

  return (
    <div className="flex flex-row gap-2 justify-around w-full h-full overflow-scroll items-center p-6 ">
      <PanelLeft selectedUrl={selectedUrl} setSelectedUrl={setSelectedUrl} />
      <PanelRight url={selectedUrl} />
    </div>
  );
};

export default NimbusDeveloperToolsEmails;
